export const ASSETS_CONFIG_LOADING = 'ASSETS_CONFIG_LOADING';
export const ASSETS_CONFIG_ERROR = 'ASSETS_CONFIG_ERROR';
export const ASSETS_CONFIG_SUCCESS = 'APEX_CHARTS_SUCCESS';